import { render } from "./extend-rights.vue?vue&type=template&id=60d0c79c"
import script from "./extend-rights.vue?vue&type=script&lang=js"
export * from "./extend-rights.vue?vue&type=script&lang=js"

import exportComponent from "/Users/n0m4dz/workspace/projects/seeroo-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__